export default __webpack_public_path__ + "static/media/Bandeau 23.5590cd15.jpg";